import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-common-button',
  templateUrl: './common-button.component.html',
  styleUrls: ['./common-button.component.scss'],
})
export class CommonButtonComponent {
  @Input() buttonText: string = 'Button';
  @Input() disabledMessage: string = 'This action is disabled';
  @Input() isDisabled: boolean = false;
  @Input() buttonClass: string = 'modelBtn';
  @Input() useTransportButton: boolean = true;
  @Output() buttonClick = new EventEmitter<void>();

  onClick(): void {
    if (!this.isDisabled) {
      this.buttonClick.emit();
    }
  }

  get fullButtonClass(): string {
    const classes = [this.buttonClass];
    if (this.useTransportButton) {
      classes.push('transportButton');
    }
    return classes.filter(c => c).join(' ');
  }
}
